

































import Vue from 'vue';
import { Component, Model, Watch, Prop } from 'vue-property-decorator'
import { HsComponent } from '@hds/help-common/src/components/hs-components'


@Component({
  middleware: async (ctx) => {
    // todo: middleware
  },
  validate: async (ctx) => {
    // todo: validate
    return true
  },
  asyncData: async (ctx) => {
    // todo: asyncData
  },
})
/**
 * @vuese
 * @group component group
 * component description
 */
export default class extends HsComponent {
  // #region variables
  @Model('value', { default: null }) value: string
  @Prop({ default: 'date' }) type: string
  @Prop({ default: undefined }) min: string | undefined
  @Prop({ default: undefined }) max: string | undefined
  @Prop({ default: undefined }) inputClass: string | undefined
  @Prop({ default: false }) disabled: boolean
  visible: boolean = false
  date: string = null
  classes: string = undefined
  // #endregion
  // #region hooks
  created() {
    this.date = this.value
    this.classes = this.inputClass
  }
  // #endregion

  // #region methods
  dayFormat(date) {
    return new Date(date).getDate()
  }

  checkDate(date) {
    console.log(date, typeof date)
    return false
  }

  click(result: boolean) {
    this.visible = false

    if (!result) this.date = this.value

    const month = new Date(this.date).getMonth() + 1 // 월은 0부터 시작하므로 +1
    const weekInfo = this.getWeekDatesMonday(this.date)

    const data = {
                    selMonthWeekNum :  month +'월 '+this.getMonthWeekNumber(this.date) + '주차' , 
                    startOfWeek : weekInfo.startOfWeek , 
                    endOfWeek : weekInfo.endOfWeek
                 }
    
    this.$emit('date-value', data)
  }

  getMonthWeekNumber(date) {
    const currentDate = new Date(date)
    const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
    const firstDayOfWeek  = startOfMonth.getDay()

    // 첫 주의 월요일로 이동시킴
    const offset = (firstDayOfWeek === 0) ? -6 : 1 - firstDayOfWeek
    const firstMonday = new Date(startOfMonth)
    firstMonday.setDate(startOfMonth.getDate() + offset);

    //주차 계산 
    const diffInDays = Math.floor((currentDate - firstMonday) / (1000*60*60*24))
    const weekNumber = Math.ceil((diffInDays+1) / 7)

    return weekNumber
  }

  getWeekDatesMonday(date) {
    const currentDate = new Date(date);
    const day = currentDate.getDay();
    const startOfWeek = new Date(currentDate);
    const endOfWeek = new Date(currentDate);

    // 월요일을 주의 첫날로 간주
    startOfWeek.setDate(currentDate.getDate() - ((day + 6) % 7));
    endOfWeek.setDate(startOfWeek.getDate() + 6);

    return {
      startOfWeek: startOfWeek.toISOString().split('T')[0],
      endOfWeek: endOfWeek.toISOString().split('T')[0]
    }
  }

  beforeDestroy() {
    console.log('Modal beforeDestroy-----------------', document.getElementsByClassName('v-dialog__content--active').length, document.querySelector('html').classList)
    this.$nextTick(function () {
      const modal = document.getElementsByClassName('v-dialog__content--active').length
      if (modal > 0) {
        setTimeout(() => document.documentElement.classList.add('overflow-y-hidden'), 100)
      } else {
        setTimeout(() => document.documentElement.classList.remove('overflow-y-hidden'), 100)
      }
    })
  }

  // #endregion

  // #region watches
  @Watch('value')
  onValueChanged(val: string) {
console.log("onValueChanged()")
    this.date = val
  }

  @Watch('visible')
  onVisibleChanged(value: string) {
    if (value) {
      this.$nextTick(function () {
        console.log('Modal -----------------', value, document.getElementsByClassName('v-dialog__content--active').length)
        setTimeout(() => document.documentElement.classList.add('overflow-y-hidden'), 100)
      })
    } else {
      this.$nextTick(function () {
        const modal = document.getElementsByClassName('v-dialog__content--active').length
        console.log('modal', modal)
        if (document.getElementsByClassName('v-dialog__content--active').length > 0) {
          setTimeout(() => document.documentElement.classList.add('overflow-y-hidden'), 100)
        }
      })
    }
  }

  @Watch('max')
  onMaxChanged(val: string) {
    this.max = val
  }

  @Watch('inputClass')
  onClassChanged(val: string) {
    this.classes = val
  }
}
